import React, { useState } from 'react';

import TpDialog from '../../shared/tp_dialog';
import { discard_guard_text } from '../../shared/dialog_logic';
import { plural } from './adapters';
import { HANDLERS } from './error_handlers';
import { UPLOAD_ERROR, UPLOAD_LIMITS } from './params';

/*
 * discard a previewed upload with a mandatory internal reason. Nothing is paid and the file stays
 * in storage as evidence; a discarded run can never be applied.
 */
const DiscardModal = ({ run, saving, error_text, on_submit, on_close, on_focus_lost }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const submit = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      setError(HANDLERS[UPLOAD_ERROR.REASON_REQUIRED].text);
      return;
    }
    on_submit(trimmed);
  };

  return (
    <TpDialog
      title_id="tp-up-discard-title"
      title="Discard this upload"
      size="sm"
      busy={saving}
      guard_text={discard_guard_text(reason)}
      on_close={on_close}
      on_focus_lost={on_focus_lost}
    >
      <div className="tp-modal">
        <div className="tp-ctx">
          <b>{run.file_name}</b> · {run.month_text} · {plural(run.counts.total, 'row')}
          <div>Nothing from this file is paid. The file stays in storage as a record.</div>
        </div>
        <div className="tp-field">
          <label htmlFor="tp-up-discard-reason">Reason for discarding (internal, required)</label>
          <textarea
            id="tp-up-discard-reason"
            className="tp-textarea"
            rows={3}
            maxLength={UPLOAD_LIMITS.REASON_MAX_LEN}
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              setError('');
            }}
            placeholder="Why this upload is being discarded"
          />
          {error ? <span className="tp-err">{error}</span> : null}
        </div>
        {error_text ? (
          <div className="tp-banner tp-banner-error" role="alert">
            {error_text}
          </div>
        ) : null}
        <div className="tp-modal-ft">
          {/* aria-disabled, not disabled: disabling the focused button drops focus. */}
          <button
            type="button"
            className="tp-btn-ghost"
            onClick={saving ? undefined : on_close}
            aria-disabled={saving ? 'true' : undefined}
          >
            Cancel
          </button>
          <button
            type="button"
            className="tp-btn tp-btn-danger"
            onClick={saving ? undefined : submit}
            aria-disabled={saving ? 'true' : undefined}
          >
            {saving ? 'Discarding…' : 'Discard upload'}
          </button>
        </div>
      </div>
    </TpDialog>
  );
};

export default DiscardModal;
